




















import {Component, Vue, Watch} from "vue-property-decorator";
import OrderCounts from "@/api/Order/OrderCounts";
import OrderService from "@/service/OrderService";

interface Indexable {
  [key: string]: string;
}

@Component
export default class OrderTypes extends Vue {
  private orderCounts: OrderCounts | null = null;

  private orderTypes: Indexable = {
    pending: "در انتظار پرداخت",
    processing: "در حال پردازش",
    complete: "تکمیل شده",
    canceled: "لغو شده",
  };

  private orderCountsIndexable: Indexable | null = null;

  private currentFilter = "pending";

  private setCurrentFilter() {
    this.currentFilter = 'pending';
    if (this.$route.query.filter) {
      this.currentFilter = this.$route.query.filter.toString();
    }
    this.setTitle();
  }

  private setTitle() {
    if (this.currentFilter) {
      document.title = 'سفارش‌های ' + this.orderTypes[this.currentFilter];
    }
  }

  private async getOrderCounts() {
    this.orderCounts = await OrderService.countOrders();
    if (this.orderCounts) {
      this.orderCountsIndexable = {
        pending: this.orderCounts.pending.toString(),
        processing: this.orderCounts.processing.toString(),
        complete: this.orderCounts.complete.toString(),
        canceled: this.orderCounts.canceled.toString(),
      }
    }
  }

  private applyOrderFilter(filter: string): void {
    const newQuery = {
      filter: filter
    }
    this.$router.push({path: '', query: newQuery})
  }

  mounted() {
    this.setCurrentFilter();
    this.getOrderCounts();
  }

  @Watch('$route.query')
  onRouteChanged() {
    this.setCurrentFilter();
  }
}
